<template>
    <div class="production-target">
        <div class="actions">
            <div class="box">
                <div class="actions-func">
                    <Input v-model="conditions.plan_id" :placeholder="$t('planID')" class="margin-r10 shadow112006" style="width: 170px"/>
                    <Input v-model="conditions.product_code" :placeholder="$t('productionNo')" class="margin-r10 shadow112006" style="width: 170px"/>
                    <Input v-model="conditions.customer_code" :placeholder="$t('customerCode')" class="margin-r10 shadow112006" style="width: 170px"/>
                    <date-picker :value="conditions.start_time" type="datetime" :placeholder="$t('startTime')" @on-change="changeSearchStart" class="margin-r10 shadow112006" style="width: 170px"/>
                    <date-picker :value="conditions.end_time" type="datetime" :placeholder="$t('endTime')" @on-change="changeSearchEnd" class="margin-r10 shadow112006" style="width: 170px"/>
                    <Button type="info" icon="md-search" @click="searchSubmit" class="shadow112006">{{$t('search')}}</Button>
                </div>
                <div class="btns">
                    <Button icon="md-open" @click="exportData" class="margin-r10 shadow112006">{{$t('exportData')}}</Button>
                    <Button icon="md-add" type="primary" @click="add" class="margin-r10 shadow112006" v-if="$store.state.user.rank==1">{{$t('add')}}</Button>
                    <Button icon="md-trash" type="error" @click="delModal = true" class="shadow112006" v-if="$store.state.user.rank==1">{{$t('delete')}}</Button>
                </div>
            </div>
        </div>
        <Table border ref="selection" :columns="columns" :data="plans" @on-selection-change="selectItem" height="873"/>
        <!-- 底部分页 -->
        <PFooter isShowPage :page="page" @change-page="changePage" @change-page-size="changePageSize"></PFooter>
        <!-- 添加弹出层 -->
        <Modal v-model="addModal.show" width="800" @on-ok="addPlan" @on-cancel="addModal.show = false" :ok-text="$t('ok')" :cancel-text="$t('cancel')">
            <p slot="header">
                <Icon type="md-add"/>
                &nbsp;{{$t('addPlan')}}
            </p>
            <Form :model="addModal.params" ref="editModal" :label-width="100">
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('groupName')" prop="gid">
                            <Select v-model="addModal.params.gid" :placeholder="$t('select')">
                                <Option v-for="(item,index) in groups" :key="'groups'+index" :value="item.gid">{{item.name}}</Option>
                            </Select>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('productionNo')" prop="product_code">
                            <Input v-model="addModal.params.product_code" :placeholder="$t('productionNo')"></Input>
                        </form-item>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('productName')" prop="product_name">
                            <Input v-model="addModal.params.product_name" :placeholder="$t('productName')"></Input>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('planTotal')" prop="total">
                            <Input v-model="addModal.params.total" :placeholder="$t('planTotal')"></Input>
                        </form-item>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('moldNo')" prop="mold_code">
                            <Input v-model="addModal.params.mold_code" :placeholder="$t('moldNo')"></Input>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('hotRunnerID')" prop="hot_runner">
                            <Input v-model="addModal.params.hot_runner" :placeholder="$t('hotRunnerID')"></Input>
                        </form-item>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('customerCode')" prop="customer_code">
                            <Input v-model="addModal.params.customer_code" :placeholder="$t('customerCode')"></Input>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('customerName')" prop="customer_name">
                            <Input v-model="addModal.params.customer_name" :placeholder="$t('customerName')"></Input>
                        </form-item>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('a_staff')" prop="person">
                            <Input v-model="addModal.params.person" :placeholder="$t('a_staff')"></Input>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('a_workClass')" prop="worktime">
                            <Select v-model="addModal.params.wt_id" :placeholder="$t('select')">
                                <Option v-for="(item,index) in worktime" :key="'worktime'+index" :value="item.wt_id">{{item.wt_name}}</Option>
                            </Select>
                        </form-item>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('startTime')" prop="start_time">
                            <date-picker type="datetime" style="width: 208px;" format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('startTime')" :value="addModal.params.start_time" @on-change="changeAddModalStartTime"></date-picker>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('endTime')" prop="end_time">
                            <date-picker type="datetime" style="width: 208px;" format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('endTime')" :value="addModal.params.end_time" @on-change="changeAddModalEndTime"></date-picker>
                        </form-item>
                    </Col>
                </Row>
            </Form>
        </Modal>
        <!-- 编辑弹出层 -->
        <Modal v-model="editModal.show" width="800" @on-ok="editPlan" @on-cancel="editModal.show = false" :ok-text="$t('ok')" :cancel-text="$t('cancel')">
            <p slot="header">
                <Icon type="md-edit"/>
                &nbsp;{{$t('editProductionPlan')}}
            </p>
            <Form :model="editModal.params" ref="editModal" :label-width="100">
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('groupName')" prop="gid">
                            <Select v-model="editModal.params.gid" :placeholder="$t('select')">
                                <Option v-for="(item,index) in groups" :key="'groups'+index" :value="item.gid">{{item.name}}</Option>
                            </Select>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('productionNo')" prop="product_no">
                            <Input v-model="editModal.params.product_code" :placeholder="$t('productionNo')"></Input>
                        </form-item>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('productName')" prop="product_name">
                            <Input v-model="editModal.params.product_name" :placeholder="$t('productName')"></Input>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('planTotal')" prop="total">
                            <Input v-model="editModal.params.total" :placeholder="$t('planTotal')"></Input>
                        </form-item>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('moldNo')" prop="mold_code">
                            <Input v-model="editModal.params.mold_code" :placeholder="$t('moldNo')"></Input>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('hotRunnerID')" prop="hot_runner">
                            <Input v-model="editModal.params.hot_runner" :placeholder="$t('hotRunnerID')"></Input>
                        </form-item>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('customerCode')" prop="customer_code">
                            <Input v-model="editModal.params.customer_code" :placeholder="$t('customerCode')"></Input>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('customerName')" prop="customer_name">
                            <Input v-model="editModal.params.customer_name" :placeholder="$t('customerName')"></Input>
                        </form-item>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('a_staff')" prop="person">
                            <Input v-model="editModal.params.person" :placeholder="$t('a_staff')"></Input>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('a_workClass')" prop="worktime">
                            <Select v-model="editModal.params.wt_id" :placeholder="$t('select')">
                                <Option v-for="(item,index) in worktime" :key="'worktime'+index" :value="item.wt_id">{{item.wt_name}}</Option>
                            </Select>
                        </form-item>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="10" offset="2">
                        <form-item :label="$t('startTime')" prop="start_time">
                            <date-picker type="datetime" style="width: 208px;" format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('startTime')" :value="editModal.params.start_time" @on-change="changeEditModalStartTime"></date-picker>
                        </form-item>
                    </Col>
                    <Col span="10">
                        <form-item :label="$t('endTime')" prop="end_time">
                            <date-picker type="datetime" style="width: 208px;" format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('endTime')" :value="editModal.params.end_time" @on-change="changeEditModalEndTime"></date-picker>
                        </form-item>
                    </Col>
                </Row>
            </Form>
        </Modal>
        <!-- 删除生产计划单 -->
        <Modal v-model="delModal" @on-ok="delPlan" @on-cancel="delModal = false" :ok-text="$t('ok')" :cancel-text="$t('cancel')" width="400">
            <p slot="header">
                <Icon type="md-trash"/>
                <span>{{$t('a_deleteProductionPlan')}}</span>
            </p>
            <p>{{$t('a_deleteProductionWaring')}}</p>
        </Modal>
    </div>
</template>
<script>
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import PFooter from '@/views/main_components/footer.vue';
import Moment from 'moment';

export default {
    components: {
        PFooter
    },
    data() {
        var columns = [
            {
                type: 'selection',
                width: 60,
                key: 'plan_id',
                align: 'center',
                fixed: 'left'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('planID'));
                },
                key: 'plan_id',
                align: 'center',
                width: 120,
                fixed: 'left'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('groupName'));
                },
                key: 'gname',
                align: 'center',
                ellipsis: true,
                width: 150
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('productionNo'));
                },
                key: 'product_code',
                align: 'center',
                width: 150,
                ellipsis: true
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('productName'));
                },
                key: 'product_name',
                align: 'center',
                width: 150,
                ellipsis: true
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('moldNo'));
                },
                key: 'mold_code',
                align: 'center',
                width: 150,
                ellipsis: true
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('hotRunnerID'));
                },
                key: 'hot_runner',
                align: 'center',
                width: 150,
                ellipsis: true
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('planTotal'));
                },
                key: 'total',
                width: 90,
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('productTotal'));
                },
                key: 'finish',
                width: 100,
                align: 'center',
                render: (h, params) => {
                    return h(
                        'span',
                        {
                            style: {
                                color: '#5a8cff'
                            }
                        },
                        params.row.finish
                    );
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_rejectNm'));
                },
                key: 'reject',
                width: 100,
                align: 'center',
                ellipsis: true
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_staff'));
                },
                key: 'person',
                align: 'center',
                width: 120,
                ellipsis: true
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_workClass'));
                },
                key: 'wt_name',
                align: 'center',
                width: 120,
                ellipsis: true
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('customerCode'));
                },
                key: 'customer_code',
                align: 'center',
                width: 150,
                ellipsis: true
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('customerName'));
                },
                key: 'customer_name',
                align: 'center',
                width: 220,
                ellipsis: true
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('startTime'));
                },
                key: 'start_time',
                align: 'center',
                width: 150,
                render: (h, params) => {
                    return h('span', Moment(params.row.start_time).format('YYYY-MM-DD HH:mm:ss'));
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('endTime'));
                },
                key: 'end_time',
                align: 'center',
                width: 150,
                render: (h, params) => {
                    return h('span', Moment(params.row.end_time).format('YYYY-MM-DD HH:mm:ss'));
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('takeTime'));
                },
                key: 'take_time',
                width: 100,
                align: 'center',
                render: (h, params) => {
                    return h('span', (params.row.take_time / 3600).toFixed(1) + 'H');
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('planStatus'));
                },
                key: 'status',
                align: 'center',
                width: 100,
                fixed: 'right',
                render: (h, params) => {
                    if (params.row.status == 2) {
                        return h(
                            'span',
                            {
                                style: {
                                    color: '#19be6b'
                                }
                            },
                            this.$t('finishPlan')
                        );
                    } else if (params.row.status == 1) {
                        return h(
                            'span',
                            {
                                style: {
                                    color: '#2d8cf0'
                                }
                            },
                            this.$t('processPlan')
                        );
                    } else {
                        return h('span', this.$t('stopPlan'));
                    }
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('action'));
                },
                key: 'action',
                width: 160,
                align: 'center',
                fixed: 'right',
                render: (h, params) => {
                    var arr = [];
                    if (params.row.status == 1) {
                        arr = [
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        disabled: true
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.edit(params.row);
                                        }
                                    }
                                },
                                this.$t('edit')
                            ),
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'success',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.stop(params.row);
                                        }
                                    }
                                },
                                this.$t('stopPlan')
                            )
                        ];
                    } else {
                        arr = [
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.edit(params.row);
                                        }
                                    }
                                },
                                this.$t('edit')
                            ),
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'default',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.start(params.row);
                                        }
                                    }
                                },
                                this.$t('startPlan')
                            )
                        ];
                    }
                    if (this.$store.state.user.rank == 2) {
                        arr.shift();
                    }
                    return h('div', arr);
                }
            }
        ];
        return {
            // intval: '', // 定时器
            plans: [], // 生产计划单数据
            groups: [], // 注塑机组下拉菜单
            worktime: [], //所有排班
            page: {
                page: 1, // 当前分页
                total: 0, // 总数
                size: 10
            }, // 分页
            conditions: {
                page: 1,
                size: 10,
                cid: this.$store.state.user.cid,
                plan_id: '', // 计划单号
                product_code: '', // 产品编号
                customer_code: '', // 任务对应客户编号
                start_time: '', // 起始时间
                end_time: '' // 结束时间
            }, // 查询条件
            checkItems: [], // 多选
            // 表格菜单
            columns,
            // 新增生产计划单
            addModal: {
                show: false, // 是否显示
                params: {
                    cid: this.$store.state.user.cid,
                    gid: '',
                    product_code: '',
                    product_name: '',
                    mold_code: '',
                    hot_runner: '',
                    total: '',
                    customer_code: '',
                    customer_name: '',
                    person: '',
                    wt_id: '',
                    start_time: '',
                    end_time: ''
                }
            },
            // 编辑生产计划单
            editModal: {
                show: false, // 是否显示
                params: {}
            },
            //删除生产计划单
            delModal: false
        };
    },
    created() {
        this.$store.commit('upNavbar', 2);
    },
    mounted() {
        // 查询生产计划单信息
        this.getPlans();
    },
    methods: {
        /////////////////////////*全局方法*/////////////////////////
        // 获取生产计划单
        getPlans() {
            Axios.get(AxiosUrl.plan.list, {
                params: this.conditions
            }).then(res => {
                if (res.data.code == 200) {
                    this.page.page = res.data.data.page;
                    this.page.total = res.data.data.total;
                    this.plans = res.data.data.list;
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        // 获取注塑机组
        getGroups() {
            Axios.get(AxiosUrl.group.select, {
                params: {
                    cid: this.$store.state.user.cid,
                    wsid: 0
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.groups = res.data.data;
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        // 获取排班情况
        getWorkTime() {
            Axios.get(AxiosUrl.worktime.list, {
                params: {
                    cid: this.$store.state.user.cid
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.worktime = res.data.data;
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        /////////////////////////*查询条件相关方法*/////////////////////////
        // 修改查询时间
        changeSearchStart(date) {
            this.conditions.start_time = date;
        },
        changeSearchEnd(date) {
            this.conditions.end_time = date;
        },
        //提交查询
        searchSubmit() {
            this.getPlans();
        },
        /////////////////////////*生产计划单相关方法*/////////////////////////
        // 导出数据
        exportData() {
            this.$refs.selection.exportCsv({
                filename: this.$t('productionPlan')
            });
        },
        // 添加开始时间
        changeAddModalStartTime(date) {
            this.addModal.params.start_time = date;
        },
        changeAddModalEndTime(date) {
            this.addModal.params.end_time = date;
        },
        // 弹出添加生产计划单
        add() {
            this.addModal.show = true;
            this.getGroups();
            this.getWorkTime();
        },
        // 确认添加
        addPlan() {
            // 计算需要的时间
            let t1 = new Date(this.addModal.params.start_time);
            let t2 = new Date(this.addModal.params.end_time);
            if (t1 >= t2) {
                this.$Message.error(this.$t('timeRangeError'));
                return;
            }
            Axios.get(AxiosUrl.plan.add, {
                params: this.addModal.params
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('addSuccess'));
                    this.addModal.params = {
                        cid: this.$store.state.user.cid,
                        gid: '',
                        product_code: '',
                        product_name: '',
                        total: '',
                        customer_code: '',
                        customer_name: '',
                        person: '',
                        worktime: '',
                        start_time: '',
                        end_time: ''
                    };
                    // 刷新列表
                    this.getPlans();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        },
        // 删除操作
        delPlan() {
            if (!this.checkItems.length) {
                this.$Message.error(this.$t('delSelectEmpty'));
                return;
            }
            // 删除
            Axios.get(AxiosUrl.plan.del, {
                params: {
                    plan_ids: this.checkItems.join('-')
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('deleteSuccess'));
                    // 刷新列表
                    this.getPlans();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        },
        // 多选选择
        selectItem(selections) {
            this.checkItems = [];
            for (let item of selections) {
                this.checkItems.push(item.plan_id);
            }
        },
        // 弹出编辑生产计划单
        edit(params) {
            this.getGroups();
            this.getWorkTime();
            this.editModal.params = Object.assign({}, params);
            this.editModal.show = true;
        },
        // 确认编辑生产计划单
        editPlan() {
            // 计算需要的时间
            let t1 = new Date(this.editModal.params.start_time);
            let t2 = new Date(this.editModal.params.end_time);
            if (t1 >= t2) {
                this.$Message.error(this.$t('timeRangeError'));
                return;
            }
            Axios.get(AxiosUrl.plan.edit, {
                params: this.editModal.params
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('updateSuccess'));
                    // 刷新列表
                    this.getPlans();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        },
        // 开始计划任务
        start(params) {
            Axios.get(AxiosUrl.plan.changestatus, {
                params: {
                    plan_id: params.plan_id,
                    status: 1
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.getPlans();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        },
        // 停止计划任务
        stop(params) {
            Axios.get(AxiosUrl.plan.changestatus, {
                params: {
                    plan_id: params.plan_id,
                    status: 0
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.getPlans();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        },
        // 修改开始时间
        changeEditModalStartTime(date) {
            this.editModal.params.start_time = date;
        },
        changeEditModalEndTime(date) {
            this.editModal.params.end_time = date;
        },
        /////////////////////////*page页相关方法*/////////////////////////
        // 改变页数
        changePage(page) {
            this.conditions.page = page;
            this.getPlans();
        },
        // 改变每页数量
        changePageSize(size) {
            this.conditions.size = size;
            this.getPlans();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/production/target.vue